/**
 * Filter function for steps array.
 *
 * @param index - The index of the current step.
 * @param isDuplication - Flag to check if it's a duplication.
 * @returns Whether the step should be included in the final array.
 *
 * At the time of duplication, we display hypotheses that won't be duplicated if they are not part of the new simulation.
 * Creation is not affected by this.
 */
export function filterSteps(index: number, isDuplication: boolean): boolean {
    if ((index === 1 || index === 2) && !isDuplication) {
        // If it's not a duplication and we're at the second step, skip this step.
        return false;
    }
    // Add any other filtering logic here
    return true;
}
